import { render, staticRenderFns } from "./userRequestList.vue?vue&type=template&id=42abfbf4&scoped=true&"
import script from "./userRequestList.vue?vue&type=script&lang=js&"
export * from "./userRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42abfbf4",
  null
  
)

export default component.exports